import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// -------

import axios from 'app/services/http/axios';
import { Actions } from './slice';

import { Api } from 'modules/Admin/Profile'

function* save({ payload }) {

  try {
    const route = Api.password;
    const response = yield call(axios.post, route, { ...payload });
    yield put(Actions.savePasswordSuccess(response));

    toast.success('Password successfully updated')

  } catch (e) {
    return yield put(Actions.savePasswordFailed(e));
  }
}

export function* watchProfileSecuritySaga() {
  yield takeLatest(Actions.savePassword.type, save)
}

export default watchProfileSecuritySaga
